var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentBox !== null)?_c('TimeConstraintList',{attrs:{"constrainedItem":_vm.currentBox,"timeConstraintType":_vm.timeConstraintType}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }